export enum PopupType {
  Primary = "color-primary",
  Secundary = "color-secondary",
  Warning = "color-warning",
  Info = "color-info",
  Danger = "color-danger",
  Success = "color-success",
}
